import { EventsOfTask } from 'pages/Tasks/types'
import type { ResolveActionButtonsProps } from 'redesign/components/templates/task-details-action-buttons/types'
import { getCommentButton } from 'redesign/components/templates/task-details-action-buttons/utils/get-comment-button'
import { getReminderButton } from 'redesign/components/templates/task-details-action-buttons/utils/get-reminder-button'
import { getShowTeamplanButton } from '../office/get-show-teamplan-button'

export const getTimelineButtons = ({
  canSendReminder,
  canSendComment,
  t,
  task,
  sendEvent,
  isOffice,
  refetch,
  setMessageDrawerProps,
  displayTeamPlanButton,
  handleButtonAction,
}: ResolveActionButtonsProps) => [
  ...(canSendReminder ? [getReminderButton({ t, task, sendEvent, isOffice, refetch })] : []),
  ...(displayTeamPlanButton ? [getShowTeamplanButton({ t, handleButtonAction })] : []),
  ...(canSendComment
    ? [
        getCommentButton({
          t,
          sendEvent,
          refetch,
          setMessageDrawerProps,
          taskEvent: EventsOfTask.absenceRequestSendCommentToManager,
        }),
      ]
    : []),
]
